@if (layout.current.headerNavigation && !layout.current.headerTopNavigationHidden && showNavigation()) {
    <div class="navigation-wrapper">
        @let vm = viewModel();
        @if (vm) {
            <nav
                id="sports-nav"
                [class.compact]="vm.isDesktopNavCompact"
                [class.separator]="vm.showSeparator"
                [class.with-pills]="isEpcotEnabled"
                [class.default]="!isEpcotEnabled">
                <ms-main-items [items]="navigation.topNavigation" [compactItems]="vm.isDesktopNavCompact" [isEpcotEnabled]="isEpcotEnabled" />
            </nav>
        }
    </div>
}
<div class="az-menu-container"></div>
